<template>
  <div class="row">
    <config-menu></config-menu>
    <div>
        <modal ref="confirm" @ok="signOutCompany()"></modal>

        <h2>退会前にお読みください</h2>
        <p>[注意]ユーザ、休暇申請、交通費、勤怠など紐づくすべてのデータが削除されます。
          <br>今月末までのご利用分が請求対象となります。
        </p>
        <button class='btn btn-primary btn-sm mt-1' @click="$refs.confirm.confirm('本当に退会しますか？')">退会する
        </button>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import CommonAPI from "../../../api/common-api.js";
import CompanyAPI from "../../../api/company-api.js";
import ConfigMenu from "./ConfigMenu.vue";
import Modal from '../../Modal.vue'

import { Card, createToken } from 'vue-stripe-elements-plus'

export default {
  name: "config-delete",
  components: {
    ConfigMenu,
    Modal,
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
      this.loginUser = val
    },
  },  
  data() {
    return {
      edit: false,
      loginUser: {
          role: ''
      },
      company: {},
    }
  },
  mounted () {
    console.log(this)
    this.getCompany()
  },
  methods: {
    // 設定取得
    getCompany () {
      this.$root.$refs.loading.$data.show = true
      CompanyAPI.get()
          .then(res => {
            this.company = res
            this.$nextTick(function() {
              $(".close").click()
              this.$root.$refs.loading.$data.show = false
            })
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
    // 退会
    signOutCompany () {    
      this.$root.$refs.loading.$data.show = true
      CompanyAPI.signOut(this.company.uuid)
        .then(res => {
          CommonAPI.logout()
              .then(res => {
                this.$root.$refs.asnHeader.$data.login = false
                this.$router.push('/login')
              })
        })
        .catch(err => {
          console.error(err)
          this.$root.$refs.loading.$data.show = false
        })
    },
  },
  filters: {
    settingEmpty: function (data) {
      return data ? data : '設定なし'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/config/ConfigSignOut.vue